(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["marquee-scroller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ai-marquee-scroller')) {
    class AiMarqueeScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ai-marquee-track');
        if (!this.track) return;

        const pauseOnHover = this.track.getAttribute('data-pause-on-hover') === 'true';

        if (pauseOnHover) {
          this.addEventListener('mouseenter', () => {
            this.track.classList.add('ai-marquee-paused');
          });

          this.addEventListener('mouseleave', () => {
            this.track.classList.remove('ai-marquee-paused');
          });
        }
      }
    }

    customElements.define('ai-marquee-scroller', AiMarqueeScroller);
  }
  } catch(e) { console.error(e); }
})();

})();
